
import { get } from './http';

const CMS_API_FREFIX = '/cms-api';

export default {
  get_know_banner_list: () => get(`${CMS_API_FREFIX}/api/banner/list`), // 推荐banner列表
  get_know_column_list: () => get(`${CMS_API_FREFIX}/column/list`), // 推荐栏目列表
  get_article_banner: (arg) => get(`${CMS_API_FREFIX}/article/banner`, arg), // banner列表
  get_article_list: (arg) => get(`${CMS_API_FREFIX}/article/list`, arg), // 栏目列表
  get_art_details_info: (params) => get(`${CMS_API_FREFIX}/article/${params.id}?accessPassword=${params.accessPassword}&accessType=${params.accessType}&readFlag=${params.clickNum}&tenantId=`), // 栏目列表
  get_article_search: (arg) => get(`${CMS_API_FREFIX}/article/searchByKeyWord`, arg), // 搜索资讯
  get_tab_list: (id) => get(`${CMS_API_FREFIX}/api/catalog/icon/list/${id}`), //栏目
  get_article_details: (arg) => get(`${CMS_API_FREFIX}/article/${arg.id}`, arg), //资讯详情
};
